import { render } from "./EmployeeRegistration.vue?vue&type=template&id=b6546516"
import script from "./EmployeeRegistration.vue?vue&type=script&lang=js"
export * from "./EmployeeRegistration.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__